import React from 'react';

import { useMsal } from '@azure/msal-react';
import { LanguageService } from '../../service/LanguageService';

function ADB2CLogout(props) 
{
  const { instance } = useMsal();
  const languageService = new LanguageService();
  
  const LogoutHandler = () => {
    try {
      console.log("Trying to logout")
      const logoutResponse = instance.logout();
      console.log(logoutResponse)
      props.onLogout();
    } catch (err) {
    console.log(err)
  }
}

  return (
    <>
      <button className="p-link" onClick={LogoutHandler}><i className="pi pi-fw pi-power-off" /><span>{languageService.getText("Logout")}</span></button>
           
    </>    
  );
}

export default ADB2CLogout;
